import {Component,Input} from '@angular/core';

@Component({
    selector: 'app-contenitore-tipo-label',
    templateUrl: './contenitore-tipo-label.component.html',
    styleUrls: ['./contenitore-tipo-label.component.scss'],
    standalone: false
})
export class ContenitoreTipoLabelComponent {
  @Input() tipoBox: number;
}
